import React, { useEffect, useState } from 'react';
import Header from '../../../src/component/Header';
import { Link } from 'react-router-dom';
import IconPen from '../../../src/component/SvgIcons/IconPen';
import IconDelete from '../../../src/component/SvgIcons/IconDelete';
import '../Events/style.css';
import IconUpdownFilter from '../../../src/component/SvgIcons/IconUpdownFilter';
import api from '../../Services/api'
import { Tooltip } from "react-tooltip";
import Pagination from '../../component/Pagination';

import { formatCountryDate } from "../../Services/countryTime";
export default function ViewComment() {
  const [users, setUsers] = useState([]);

  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const itemsPerPage = 15;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const commentsResponse = await api.post("/feedbacks");
        const repliesResponse = await api.post("/Viewreplies");

        const comments = commentsResponse.data?.feedbacks || [];
        const replies = repliesResponse.data?.data || [];

        const combinedData = comments.map((comment) => {
          const reply = replies.find((r) => r.replied_id === comment.id) || {};
          return {
            id: comment.id,
            CommentDate: comment.Feedbacks_date,
            CommentUserName: comment.username,
            CommentEmail: comment.email,
            Comment: comment.message,
            ReplyUsername: reply.reply_username || "N/A",
            ReplyDate: reply.reply_date || "N/A",
            Reply: reply.reply || "No reply available",
          };
        });

        setUsers(combinedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const sortedUsers = [...users].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  const filteredUsers = sortedUsers.filter(user => {
    const formattedDate = user.CommentDate
      ? formatCountryDate(user.CommentDate).replace(/\//g, '-')
      : '';

    return (
      formattedDate.includes(searchQuery) ||
      (user.CommentUserName?.toLowerCase().includes(searchQuery.toLowerCase()) || false) ||
      (user.CommentEmail?.toLowerCase().includes(searchQuery.toLowerCase()) || false) ||
      (user.Comment?.toLowerCase().includes(searchQuery.toLowerCase()) || false) ||
      (user.ReplyDate?.toLowerCase().includes(searchQuery.toLowerCase()) || false) ||
      (user.ReplyUsername?.toLowerCase().includes(searchQuery.toLowerCase()) || false) ||
      (user.Reply?.toLowerCase().includes(searchQuery.toLowerCase()) || false)
    );
  });


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleDelete = (id) => {
    setUsers(users.filter(user => user.id !== id));
  };

  return (
    <section className='eventpage'>
      <Header pageTitle="Comments - View Replies" backTo="/comments" />
      <div className='pageLeftspace'>


        <div className="d-flex justify-content-between align-items-center topsearchbar">
          <div className="d-flex align-items-center gap-2">

            <Link to="#" onClick={() => handleSort("CommentDate")}>
              <IconUpdownFilter />
            </Link>
          </div>



          <div className="input-container ">
            <input
              type="text"
              id="name"
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder=""

            />
            <label htmlFor="name">Search</label>
            <span className="underline"></span>

          </div>

        </div>

        <div className="tableheader d-flex flex-column gap-4">
          <div className='event-detailstable'>
            <table className="table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th> Date</th>
                  <th >Comment User</th>
                  <th>Comment Email</th>
                  <th>Comment</th>
                  <th>Reply Date</th>
                  <th >Reply User</th>
                  <th >Reply</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.length > 0 ? (
                  currentUsers.map((user, index) => (
                    <tr key={user.id}>

                      <td align="center">{indexOfFirstItem + index + 1}</td>
                      <td>
                        {formatCountryDate(user.CommentDate).replace(/\//g, '-')}
                      </td>
                      <td>{user.CommentUserName}</td>
                      <td>{user.CommentEmail}</td>

                      <td data-tooltip-id={`blog-tooltip-${user.id}`} data-tooltip-content={user.Comment ? user.Comment.replace(/<\/?[^>]+(>|$)/g, "") : ""}>
                        {user.Comment
                          ? (user.Comment.replace(/<\/?[^>]+(>|$)/g, "").length > 20
                            ? `${user.Comment.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 50)}...`
                            : user.Comment.replace(/<\/?[^>]+(>|$)/g, ""))
                          : ""}

                        <Tooltip
                          id={`blog-tooltip-${user.id}`}
                          place="top"
                          effect="solid"
                          style={{ whiteSpace: 'normal', maxWidth: '400px' }}
                        />
                      </td>

                      <td>
                        {formatCountryDate(user.ReplyDate)}
                      </td>

                      <td>{user.ReplyUsername}</td>
                      <td>{user.Reply}</td>
                      <td>
                        <div className='action'>
                          <Link className="editbtn"><IconPen /></Link>
                          <Link to="#" onClick={() => handleDelete(user.id)}><IconDelete /></Link>

                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={users.length > itemsPerPage ? totalPages : 0}
            onPageChange={handlePageChange}
          />

        </div>
      </div>
    </section>
  );
}
